import { render, staticRenderFns } from "./ImpactEntryToRequirementEditPart.vue?vue&type=template&id=484c53f5&scoped=true&"
import script from "./ImpactEntryToRequirementEditPart.vue?vue&type=script&lang=ts&"
export * from "./ImpactEntryToRequirementEditPart.vue?vue&type=script&lang=ts&"
import style0 from "./ImpactEntryToRequirementEditPart.vue?vue&type=style&index=0&id=484c53f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484c53f5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardActions,VCardSubtitle,VIcon,VMenu,VSpacer,VTooltip})
